module.exports = __webpack_public_path__ + "static/media/ic-flag-id.272961ce.svg";